import { render, staticRenderFns } from "./submenu.vue?vue&type=template&id=11542cf5&"
import script from "./submenu.vue?vue&type=script&lang=js&"
export * from "./submenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "submenu.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/base/menu/submenu.vue
// module id = 132
// module chunks = 0